import { render, staticRenderFns } from "./tabsHtml.vue?vue&type=template&id=a822dba8&"
import script from "./tabsHtml.vue?vue&type=script&lang=js&"
export * from "./tabsHtml.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports